import NadchodzacyWyjazd from "konto/Wyjazdy/Nadchodzące/NadchodzacyWyjazd/NadchodzacyWyjazd"

export default NadchodzacyWyjazd
